import MainTablet from './MainTablet';

export default MainTablet;
export { MainTablet };
